import { render } from "./WorldMembers.vue?vue&type=template&id=20c452c9"
import script from "./WorldMembers.vue?vue&type=script&lang=js"
export * from "./WorldMembers.vue?vue&type=script&lang=js"
script.render = render

export default script